export default "__VITE_ASSET__CvgK95Ei__"